import React, { Component } from "react";

const elementOverlap = ({ pageX: x, pageY: y }) => element => {
  const { top, left, height, width } = element;
  if (y < top) return false;
  if (x < left) return false;
  if (y > top + height) return false;
  if (x > left + width) return false;
  return true;
};

export default class SwipeToggle extends Component {
  componentDidMount() {
    const { selector } = this.props;
    document.addEventListener("mousedown", this.startDragging.bind(this));
    document.addEventListener("touchstart", this.startDragging.bind(this));
    document.addEventListener("mousemove", this.onMouseMovement.bind(this));
    document.addEventListener("touchmove", this.onTouchMovement.bind(this));
    document.addEventListener("mouseup", this.stopDragging.bind(this));
    document.addEventListener("touchend", this.stopDragging.bind(this));
    this.selectable = [...document.querySelectorAll(`[${selector}]`)].map(
      el => {
        const { top, left, height, width } = el.getBoundingClientRect();
        const value = el.getAttribute(selector);
        return { top, left, height, width, value };
      }
    );
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.startDragging.bind(this));
    document.removeEventListener("touchstart", this.startDragging.bind(this));
    document.removeEventListener("mousemove", this.onMouseMovement.bind(this));
    document.removeEventListener("touchmove", this.onTouchMovement.bind(this));
    document.removeEventListener("mouseup", this.stopDragging.bind(this));
    document.removeEventListener("touchend", this.stopDragging.bind(this));
  }

  startDragging(ev) {
    ev.stopPropagation();
    this.dragging = true;
  }

  stopDragging(ev) {
    ev.stopPropagation();
    this.dragging = false;
  }

  onTouchMovement(ev) {
    ev.stopPropagation();
    const { handleDragOver } = this.props;
    if (this.dragging) {
      const position = ev.targetTouches[0];
      const closestChild = this.selectable.find(elementOverlap(position));
      if (closestChild && closestChild !== this.recentChild) {
        handleDragOver(closestChild.value);
      }
      this.recentChild = closestChild;
    }
  }

  onMouseMovement(ev) {
    const { selector, handleDragOver } = this.props;
    if (this.dragging) {
      const closestChild = ev.target.closest(`[${selector}]`);
      if (closestChild && closestChild !== this.recentChild) {
        const value = closestChild.getAttribute(selector);
        handleDragOver(value);
      }
      this.recentChild = closestChild;
    }
  }

  render() {
    const { children, selector, handleDragOver, ...props } = this.props;
    return <div {...props}>{children}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/SwipeToggle/index.js